import React from 'react';

/**
 * El logo de Google Sheets, dibujado en línea.
 *
 * El repo sólo tenía `SheetLogo`, que es un ícono genérico de CSV (`images/csv_logo.png`): sirve para
 * el canal «CSV online», pero no dice «Google Sheets». El media plan se conecta como una planilla de
 * Google y el camino «Desde un media plan» lo muestra con este logo (QA de fede, 02/10). En SVG para
 * que escale sin un PNG por tamaño.
 */
export function GoogleSheetsLogo({size = 20, className}) {
    return (
        <svg className={className} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true"
             focusable="false">
            <path fill="#0F9D58" d="M14.5 1.5H6.2a1.7 1.7 0 0 0-1.7 1.7v17.6c0 .94.76 1.7 1.7 1.7h11.6c.94 0 1.7-.76 1.7-1.7V6.5z"/>
            <path fill="#87CEAC" d="M14.5 1.5v5h5z"/>
            <path fill="#FFFFFF" d="M7.5 10.5h9v8h-9z"/>
            <path fill="#0F9D58" d="M7.5 13h9v1h-9zM7.5 16h9v1h-9zM11.5 10.5h1v8h-1z"/>
        </svg>
    );
}
